<template>
  <transition name="fade-top" mode="out-in" appear>
    <slot></slot>
  </transition>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "TransitionFromTop"
});
</script>

<style scoped>
.fade-top-enter-active,
.fade-top-leave-active {
  transition: all 0.3s ease;
}

.fade-top-enter-from,
.fade-top-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-top-enter-to,
.fade-top-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
